import { decodeAalFromJwt } from './aalClaim';

/**
 * RD-PERF-004: who is signed in and at which assurance level RIGHT NOW, read from
 * the access token the next request would use. Returns null when anything is
 * missing or undecodable — callers must treat null as "do not trust, fetch".
 * @returns {Promise<{ userId: string, aal: 'aal1'|'aal2' } | null>}
 */
export async function readSessionAal(client) {
  try {
    const { data } = await client.auth.getSession();
    const session = data?.session;
    const userId = session?.user?.id;
    const aal = decodeAalFromJwt(session?.access_token);
    if (!userId || (aal !== 'aal1' && aal !== 'aal2')) return null;
    return { userId, aal };
  } catch {
    return null;
  }
}

export default readSessionAal;
